import React, { useEffect, useState } from "react"
import classnames from "classnames"
import facebook from "../images/share/fbShare.svg"
import twitter from "../images/share/twitterShare.svg"
import email from "../images/share/emailShare.svg"
import linkedin from "../images/share/linkedinShare.svg"
import linkShare from "../images/share/linkShare.svg"

import "./styles.scss"
import useOnClickOutside from "use-onclickoutside"
import { useParams } from "react-router-dom"
import getSelectionsFromParams from "../utils/getSelectionsFromParams"
import DataLoader, { latestYear } from "../DataLoader"
import classNames from "classnames"
function share(site, selections) {
  return () => {
    let url = null
    if (typeof document !== "undefined") {
      url = encodeURIComponent(document.location)
    } else {
      return
    }
    // console.log(url)
    let description = "WJP Rule of Law Index"
    if (selections) {
      const { selectedYear, selectedCountry, selectedFactor } = selections
      // Share pages (with preview images) only exist for the latest year.
      // Other years share the page URL itself.
      const isLatestYear = String(selectedYear) === String(latestYear)
      const countryData = DataLoader.dataByYear?.[selectedYear]?.countries ?? []
      const country = countryData.find((c) => c.Country === selectedCountry)
      if (
        isLatestYear &&
        selectedCountry &&
        selectedFactor &&
        url.includes(encodeURIComponent("/factors/"))
      ) {
        url = `${document.location.origin}${
          process.env.PUBLIC_URL
        }/s/share/Factor-${encodeURIComponent(
          selectedCountry.replace(/ /g, "_"),
        )}-${encodeURIComponent(
          selectedFactor.replace(/ /g, "_"),
        )}-${latestYear}.html`
      } else if (
        selectedCountry &&
        url.includes(encodeURIComponent("/country/"))
      ) {
        if (isLatestYear) {
          url = `${document.location.origin}${
            process.env.PUBLIC_URL
          }/s/share/Ranking-${encodeURIComponent(
            selectedCountry.replace(/ /g, "_"),
          )}-${latestYear}.html`
        }
        if (country) {
          description += ` ${country.Country} ranks ${country["overall_Rank_Global"]} out of ${countryData.length} countries on Rule of Law`
          if (!isLatestYear) {
            description += ` in ${selectedYear}`
          }
        }
      } else if (
        isLatestYear &&
        selectedCountry &&
        url.includes(encodeURIComponent("/factors/")) &&
        !selectedFactor
      ) {
        url = `${document.location.origin}${
          process.env.PUBLIC_URL
        }/s/share/FactorOverall-${encodeURIComponent(
          selectedCountry.replace(/ /g, "_"),
        )}-${latestYear}.html`
      }
    }
    // console.log(DataLoader)
    if (url) {
      let link = null
      switch (site) {
        case "facebook":
          link = `https://www.facebook.com/sharer.php?u=${url}`

          if (window.gtag) {
            window.gtag("event", "share", {
              event_category: "share",
              event_label: "facebook",
            })
          }
          break
        case "twitter":
          link = `https://twitter.com/intent/tweet?url=${url}&text=${encodeURIComponent(description)}`

          if (window.gtag) {
            window.gtag("event", "share", {
              event_category: "share",
              event_label: "twitter",
            })
          }
          break
        case "email":
          link = `mailto:?subject=${encodeURIComponent(description)}&body=${url}`

          if (window.gtag) {
            window.gtag("event", "share", {
              event_category: "share",
              event_label: "email",
            })
          }
          break
        case "linkedin":
          link = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`

          if (window.gtag) {
            window.gtag("event", "share", {
              event_category: "share",
              event_label: "linkedin",
            })
          }
          break
        case "link":
          // copy link to clipboard
          if (typeof document !== "undefined") {
            const el = document.createElement("textarea")
            el.value = decodeURIComponent(url)
            document.body.appendChild(el)
            el.select()
            document.execCommand("copy")
            document.body.removeChild(el)
          }

          if (window.gtag) {
            window.gtag("event", "share", {
              event_category: "share",
              event_label: "link",
            })
          }
          break
        default:
          alert(`sharing via ${site} not yet implemented`)
          break
      }
      if (link !== null) {
        window.open(link)
      }
    }
  }
}
export default function ShareButtons(props) {
  const { wrapperRef } = props
  useOnClickOutside(wrapperRef, props.toggle)
  const params = useParams()
  const selections = getSelectionsFromParams(params)
  // console.log(selections)
  const [copiedToClipboard, setCopiedToClipboard] = useState(false)
  const copyToClipboard = () => {
    share("link", selections)()
    setCopiedToClipboard(true)
  }
  useEffect(() => {
    if (copiedToClipboard) {
      setTimeout(() => {
        setCopiedToClipboard(false)
      }, 2000)
    }
  }, [copiedToClipboard])
  return (
    <>
      <div
        className={classnames("shareButtons", { rightAlign: props.rightAlign })}
      >
        <div className="shareButtonsWrapper">
          <img
            src={facebook}
            alt="share on facebook"
            onClick={share("facebook", selections)}
          />
          <img
            src={twitter}
            alt="share on twitter"
            onClick={share("twitter", selections)}
          />
          <img
            src={email}
            alt="share via email"
            onClick={share("email", selections)}
          />
          <img
            src={linkedin}
            alt="share via linkedin"
            onClick={share("linkedin", selections)}
          />
          <img
            src={linkShare}
            alt="copy link to clipboard"
            onClick={copyToClipboard}
          />
        </div>
        <div
          className={classNames("copiedToClipboard", {
            visible: copiedToClipboard,
          })}
        >
          link copied to clipboard
        </div>
      </div>
    </>
  )
}
